import { render, staticRenderFns } from "./RegisterAbsence.vue?vue&type=template&id=33152698&scoped=true"
import script from "./RegisterAbsence.vue?vue&type=script&lang=js"
export * from "./RegisterAbsence.vue?vue&type=script&lang=js"
import style0 from "./RegisterAbsence.vue?vue&type=style&index=0&id=33152698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33152698",
  null
  
)

export default component.exports